import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComercialRoutingModule } from './comercial-routing.module';
import { PerfilComponent } from './perfil/perfil.component';
import { SharedModule } from '../../shared/shared.module';
import { TendenciaComponent } from './tendencia/tendencia.component';
import { MetasComponent } from './metas/metas.component';

@NgModule({
  declarations: [
    PerfilComponent,
    TendenciaComponent,
    MetasComponent
  ],
  imports: [
    CommonModule,
    ComercialRoutingModule,
    SharedModule
  ],
})
export class ComercialModule {}
